<template>
    <print-layout>
        <div class="print-container">
            <div v-for="(order, index) in orders" :key="index">
                <heading-info
                    :order="order"
                    :type="'confirmation'"
                />

                <order-list 
                    :order="order"
                    :type="'confirmation'"
                />

                <div v-if="order.is_wholesale && order.customer && order.customer.show_printed_order_pricing" class="text-xs mt-2">
                    Prices subject to change from time of order to final invoice.
                </div>

                <div class="text-sm mt-6" :class="{'mt-4': order.is_wholesale && order.customer && order.customer.show_printed_order_pricing}">
                    Thank you for your order!
                    Please note all credits must be reported to sales@fresherproduce.ca within <b>the same day</b> of receiving your order.
                    Our customer care team will arrange pick up, and all credits will be issued once it arrives back to our warehouse upon inspection.
                </div>

                <div class="page-break"></div>

                <!-- Seperate Pages For Subitems -->

                <sub-items
                    :order="order"
                />
            </div>
        </div>
    </print-layout>
</template>

<script>
import PrintLayout from '@/Layouts/PrintLayout.vue';
import HeadingInfo from '@/Pages/Orders/Prints/Partials/HeadingInfo.vue';
import OrderList from '@/Pages/Orders/Prints/Partials/OrderList.vue';
import SubItems from '@/Pages/Orders/Prints/Partials/SubItems.vue';

export default {
    components: {
        PrintLayout,
        HeadingInfo,
        OrderList,
        SubItems
    },

    props: ['orders'],

    methods: {
    },

    mounted () {
        if (route().params.download === undefined) {
            window.print();

            window.onafterprint = function() {
                window.close();
            };
            window.onfocus = function() {
                window.close();
            };
        }
    }
}

</script>

<style>
    body {
        font-size: 90%;
        height: 100%;
    }

    table {
        width: 100%;
    }

    table td {
        -webkit-print-color-adjust: exact;
    }

    .combo_with_integrated_subitems {
        background-color: #EEEEEE;
        color: #515558!important;
    }

    .page-break {
        page-break-after: always;
    }

    .subheader th {
        background: #cbcbcb;
        -webkit-print-color-adjust: exact;
    }

    .signature {
        @apply border-r-0 border-l-0 border-t-0 border-b border-gray-dark !important;
    }

    .footer {
        position: fixed;
        bottom: 0px;
        left: 0px;
        width: 100%;
    }

    @media screen {
        .print-container {
            display: none;
        }
    }

    .striped tr:nth-child(even):not(.not_striped) {
        background-color: #f2f2f2;
    }
</style>
